import React from 'react';
import { X, BookOpen, Download } from 'lucide-react';

const INPUT_CLS = 'w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#143160] focus:outline-none text-gray-800 font-medium';

const FIELDS = [
  { key: 'name', type: 'text', placeholder: 'Your Name *', label: 'Your name', autoComplete: 'name' },
  { key: 'email', type: 'email', placeholder: 'Email Address *', label: 'Email address', autoComplete: 'email' },
  { key: 'phone', type: 'tel', placeholder: 'Phone Number *', label: 'Phone number', autoComplete: 'tel' },
];

export const GuideModalHeader = ({ guideType, onClose }) => (
  <div className="bg-gradient-to-r from-[#143160] to-[#1E4A86] p-6 text-center">
    <button onClick={onClose} data-testid="guide-modal-close" className="absolute top-4 right-4 text-white/80 hover:text-white transition-colors"><X className="w-6 h-6" /></button>
    <div className="inline-flex items-center justify-center w-16 h-16 bg-gold-400 rounded-2xl shadow-lg mb-4"><BookOpen className="w-8 h-8 text-[#143160]" /></div>
    <h3 className="text-2xl font-serif font-bold text-white">FREE {guideType === 'buyer' ? "Buyer's" : "Seller's"} Guide</h3>
    <p className="text-white/80 text-sm mt-2">
      {guideType === 'buyer' ? 'Everything you need to know about buying a home in Virginia & North Carolina' : 'Expert tips to sell your home faster and for top dollar'}
    </p>
  </div>
);

export const GuideSuccess = () => (
  <div className="text-center py-8">
    <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
      <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
    </div>
    <h4 className="text-xl font-bold text-gray-900 mb-2">Thank You!</h4>
    <p className="text-gray-600">Your guide is on its way to your inbox!</p>
    <p className="text-sm text-gray-500 mt-2">Jess will also reach out personally to answer any questions.</p>
  </div>
);

export const GuideForm = ({ form, setForm, onSubmit, submitting, onPrivacyClick }) => (
  <form onSubmit={onSubmit} className="space-y-4" data-testid="guide-form">
    {FIELDS.map((f) => (
      <input key={f.key} type={f.type} placeholder={f.placeholder} required aria-label={f.label} autoComplete={f.autoComplete} value={form[f.key]} onChange={(e) => setForm({ ...form, [f.key]: e.target.value })} className={INPUT_CLS} />
    ))}
    <div className="flex items-start space-x-3 bg-gold-100 p-3 rounded-xl border border-gold-200">
      <input type="checkbox" id="guideSmsConsent" className="mt-1 w-4 h-4" checked={form.smsConsent} onChange={(e) => setForm({ ...form, smsConsent: e.target.checked })} style={{ accentColor: '#143160' }} />
      <label htmlFor="guideSmsConsent" className="text-xs text-gray-600 leading-relaxed">
        I agree to be contacted by Jess Sells East Coast via call, email, and text for real estate services. To opt-out, you can reply 'STOP' at any time or reply 'HELP' for assistance. Message and data rates may apply. Message frequency may vary.{' '}
        <button type="button" onClick={onPrivacyClick} className="text-[#143160] underline font-semibold hover:text-gold-600">Privacy Policy</button>.
      </label>
    </div>
    <button type="submit" disabled={submitting} data-testid="guide-submit" className="w-full bg-gradient-to-r from-[#143160] to-[#1E4A86] hover:from-[#1E4A86] hover:to-[#143160] text-white py-4 rounded-xl font-bold text-lg flex items-center justify-center space-x-2 transition-all hover:scale-[1.02] disabled:opacity-70 disabled:cursor-wait disabled:hover:scale-100">
      <Download className="w-5 h-5" />
      <span>{submitting ? 'Sending…' : 'Get My FREE Guide'}</span>
    </button>
    <p className="text-xs text-center text-gray-500">🔒 Your information is secure and will never be shared.</p>
  </form>
);

export const GuideTypeToggle = ({ guideType, setGuideType }) => (
  <div className="px-6 pb-6">
    <div className="flex rounded-xl bg-gray-100 p-1">
      {['buyer', 'seller'].map((t) => (
        <button key={t} onClick={() => setGuideType(t)} className={`flex-1 py-2 rounded-lg text-sm font-semibold transition-all ${guideType === t ? 'bg-[#143160] text-white shadow' : 'text-gray-600 hover:text-gray-900'}`}>
          {t === 'buyer' ? "Buyer's Guide" : "Seller's Guide"}
        </button>
      ))}
    </div>
  </div>
);
